import { CustomerType } from '@graphql/index';
import { useApplicationData, useOpenBankingSteps, useStepperActiveIndex } from '@provider';
import { determineApplicationSteps } from '../../pages/ApplicationForm/hooks';

/** The step key (APPLICATION_STEPS value) for the stepper's active index. */
export function useActiveStepKey(): string | undefined {
  const activeIndex = useStepperActiveIndex();
  const { quote, Finance } = useApplicationData(['quote', 'Finance']);
  const { isOpenBankingConsentComplete } = useOpenBankingSteps();

  const steps = determineApplicationSteps(
    quote?.financialProduct?.customerType ?? CustomerType.Residential,
    Finance?.payment?.isCashApplication,
    isOpenBankingConsentComplete,
  );

  return steps[activeIndex];
}
